// Tag work time as Trusstor's own dashboard prints it beside an area: hours,
// to the half hour under ten and to the hour above (Trusstor's
// `getProductRoundedHoursFromMs`) — the same fact should round the same way in
// both products. `null` when it rounds to nothing: a quarter hour of presence
// is not worth a "0h" on every cell.

const MS_PER_HOUR = 3_600_000;

export function roundedWorkHours(ms: number): number | null {
  const hours = ms / MS_PER_HOUR;
  const rounded = hours < 10 ? Math.round(hours * 2) / 2 : Math.round(hours);
  return rounded > 0 ? rounded : null;
}
